import { Component, OnInit } from '@angular/core';
import { ErrorLogService,ScrollService } from '../api';

@Component({
  selector: 'app-four04',
  templateUrl: './four04.component.html',
  styleUrls: ['./four04.component.css']
})
export class Four04Component implements OnInit {

  constructor(private errorService: ErrorLogService,private scrollBroadcastService: ScrollService) { }

  ngOnInit() {
    this.errorService.sendToServer('Not Found : 404');
    this.scrollBroadcastService.enableScrollIfDisabled();
  }
    openSideNav(type: string) {
        this.scrollBroadcastService.openSideNav(type);
    }
}



// WEBPACK FOOTER //
// ./src/app/four04/four04.component.ts